export const RELOAD_INVENTORY_REQUEST = "RELOAD_INVENTORY_REQUEST";
export const RELOAD_INVENTORY_SUCCESS = "RELOAD_INVENTORY_SUCCESS";
export const SAVE_INVENTORY_FILTER = "SAVE_INVENTORY_FILTER";
export const FETCH_PRODUCT_REQUEST = "FETCH_PRODUCT_REQUEST";
export const FETCH_PRODUCT_SUCCESS = "FETCH_PRODUCT_SUCCESS";
export const FETCH_PRODUCT_FAILURE = "FETCH_PRODUCT_FAILURE";
export const SHOW_TILES = "SHOW_TILES";
export const HIDE_TILES = "HIDE_TILES";
